export const hasHappened = (storageKey: string, constant: number, diff: number) => {
  const lastDismissed = localStorage.getItem(storageKey);

  if (lastDismissed) {
    const lastDismissedDate = new Date(lastDismissed);
    const currentDate = new Date();
    const differenceInSeconds = (currentDate.getTime() - lastDismissedDate.getTime()) / (1000 * constant);
    if (differenceInSeconds < diff) {
      return true;
    }
  }

  return false;
};
